import Joi from '@hapi/joi'

export const MonthlyCollectionSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name is required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate Name").messages({
        "any.invalid": `Estate Name cannot have invalid characters`,
        "any.required": `Estate Name is required`
    }),
    toDate: Joi.string().invalid("").label("To date"),
    fromDate: Joi.string().invalid("").label("From date"),
    regNumber: Joi.string().label("Registration Number").messages({
        "any.invalid": `Registration number cannot have invalid characters`,
        "any.required": `Registration Number is required`
    }),
    employeeType: Joi.number().required().label("Employee Type").messages({
        "any.invalid": `Employee Type cannot have invalid characters`,
        "any.required": `Employee Type is required`
    }),
}